import React from "react";
import { AddDashedButton } from "./AddDashedButton";
import { Glyph } from "../SmallIconButton";

export const ProductPickerButton = ({
  onClick,
  dataCy,
  highlighted = false,
  className,
}: {
  onClick?: () => void;
  dataCy?: string;
  highlighted?: boolean;
  className?: string;
}) => (
  <AddDashedButton
    className={className}
    dataCy={dataCy}
    tone={highlighted ? "gold" : "line"}
    onClick={onClick}
  >
    <Glyph icon="purchase" size={20} />
    <span>Produkt wählen</span>
  </AddDashedButton>
);
